import { PayeeRequirement } from "@wingspanhq/wingspan-api-sdk";

import { getRequirementDefinitionTableCellProps } from "../../../../RequirementDefinitions/utils";
import { CustomRequirement } from "../../../types";
import { getRegistrationRequirementName } from "../../Registration/configs/helpers/getRegistrationRequirementName";
import { getRegistrationRequirementPayerStatusCell } from "../../Registration/configs/helpers/getRegistrationRequirementPayerStatusCell";
import { getClientsCellProps } from "../helpers/getClientsCellProps";

export function useGetRegistrationCustomRequirement(): (
  requirements: PayeeRequirement[]
) => CustomRequirement {
  return requirements => {
    const baseRequirement = requirements[0];
    return {
      payerAccountId: baseRequirement.payerAccountId!,
      status: baseRequirement.status!,
      nameCell: {
        text: getRegistrationRequirementName(baseRequirement)
      },
      typeCell: getRequirementDefinitionTableCellProps({
        type: baseRequirement.type!
      }),
      clientsCell: getClientsCellProps(requirements),
      engagementsCell: {},
      statusCell: getRegistrationRequirementPayerStatusCell(baseRequirement),
      menuActions: []
    };
  };
}
